import { useState, useEffect } from 'react';
import serviceUtils from '../utils';

export const useValidatedState = (
    initialValue = null,
    initialCondition = [],
    initialState = false,
) => {
    const [value, setValue] = useState(initialValue);
    const [isValid, setIsValid] = useState(initialState);
    const [conditions] = useState(initialCondition);

    const testArrayConditions = () => conditions.every((condition) => {
            switch (typeof condition) {
                case 'object':
                    return condition.test(value);
                case 'function':
                    return condition(value);
                default:
                    return false;
            }
        });

    const testCondition = () => {
        switch (typeof conditions) {
            case 'object':
                return conditions.test(value);
            case 'function':
                return conditions(value);
            default:
                return false;
        }
    };

    useEffect(() => {
        const testedPositive = Array.isArray(conditions)
            ? testArrayConditions()
            : testCondition();
        setIsValid(testedPositive);
    }, [value]);

    return [value, setValue, isValid];
};

// eslint-disable-next-line no-useless-escape
export const EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NOT_EMPTY = /^(?!\s*$).+/;
// eslint-disable-next-line no-useless-escape
export const URL = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
// eslint-disable-next-line no-useless-escape
export const EMPTY_URL = /^$|^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
// eslint-disable-next-line no-useless-escape
export const FACEBOOK_URL = /^(?:https?:\/\/)?(?:www\.|m\.|mobile\.|touch\.|mbasic\.|web\.)?(?:facebook\.com|fb(?:\.me|\.com))\/(?!$)(?:(?:\w)*#!\/)?(?:pages\/)?(?:photo\.php\?fbid=)?(?:[\w\-]*\/)*?(?:\/)?(?:profile\.php\?id=)?([^\/?&\s]*)(?:\/|&|\?)?.*$/i;
// eslint-disable-next-line no-useless-escape
export const INSTAGRAM_URL = /(?:(?:http|https):\/\/)?(?:www\.)?(?:instagram\.com|instagr\.am)\/([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/i;

export const NOT_NULL = () => function fn(value) {
    return value !== null;
};

export const MORE_THAN = (minimum, equals = false) => function fn(value) {
        return equals ? value >= minimum : value > minimum;
    };

export const MORE_THAN_CURRENCY = (minimum, equals = false) => function fn(value) {
    return equals
        ? serviceUtils.currencyToFloat(value) >= minimum
        : serviceUtils.currencyToFloat(value) > minimum;
};

export const LESS_THAN = (minimum, equals = false) => function fn(value) {
        return equals ? value <= minimum : value < minimum;
    };

export const LESS_THAN_CURRENCY = (minimum, equals = false) => function fn(value) {
    return equals
        ? serviceUtils.currencyToFloat(value) <= minimum
        : serviceUtils.currencyToFloat(value) < minimum;
};

export const MIN_LENGHT = (minimum, equals = false) => function fn(value) {
    return equals ? value.size() >= minimum : value.size() > minimum;
};

export const IS_TRUE = () => function fn(value) {
    return value;
};

export const IS_FALSE = () => function fn(value) {
    return !value;
};
